import NotesIcon from '@image/notes-menu-icon.svg';
import { NavigationPages } from '@ax/constants';

export const adminSidebarNavData = [
  {
    title: 'Notes',
    page: [NavigationPages.AdminNotes, NavigationPages.connectedNotes],
    icon: NotesIcon,
  },
];
